/*import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import router from './router'

loadFonts()

createApp(App).use(router)
  .use(vuetify)
  .mount('#app')*/

import { createApp } from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import { loadFonts } from './plugins/webfontloader';
import router from './router';
import store from './stores/store.js';
//import RedirectCartView from './components/RedirectCartView.vue';

loadFonts();

const app = createApp(App)
  .use(router)
  .use(vuetify)
  .use(store);

//app.component('shopping-cart', RedirectCartView);

app.mount('#app');